export default __webpack_public_path__ + "static/media/playstore-badge.f4df8ede.svg";